import React, { useContext, forwardRef } from 'react';
import styled, { ThemeContext } from 'styled-components';
import { Icon, IconProps } from 'semantic-ui-react';

const CustomIcon = forwardRef<HTMLElement, IconProps>((props, ref) => {
  const data = useContext(ThemeContext);

  return (
    <StyledCustomIcon
      ref={ref}
      customcolor={props.color ? props.color : data?.firstColor}
      as={props.as}
      link={props.link}
      className={props.size === 'large' ? `${props.name} table-large-icons` : `${props.name}`}
      size={props.size}
      {...props}
      name={props.name}
    />
  );
});

export default CustomIcon;

const StyledCustomIcon = styled(Icon)`
  color: ${(props) => (props.customcolor ? props.customcolor : 'inherit')} !important;
  cursor: pointer;
  margin-right: 15px !important;
  opacity: 1 !important;
  vertical-align: middle !important;
`;
